import ParamHelper from "../helpers/param.helper";
import Logger from "../scrollmagic/utils/logger";
import TypeHelper from "../helpers/type.helper";
import { merge } from "../utils";
var ParallaxBuilder = /** @class */ (function () {
    function ParallaxBuilder(name, defaultOptions) {
        if (name !== undefined && !ParamHelper.isString(name)) {
            throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Parallax name isn't a valid string: \"" + name + "\"");
        }
        if (defaultOptions !== undefined && !TypeHelper.isParallaxDescriptor(defaultOptions)) {
            throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Parallax default options aren't a valid object.");
        }
        if (defaultOptions && defaultOptions.name) {
            throw new Error("[" + ParallaxBuilder.NAMESPACE + "] It's not possible to set a default name.");
        }
        this.descriptor = merge({
            name: name,
            enabled: true,
            type: "global",
            speed: 1,
            momentum: 0.3,
            ease: "none",
            duration: "100%",
            hook: 0.5,
            offset: 0,
        }, defaultOptions);
    }
    ParallaxBuilder.prototype.element = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isHTMLElement(value)) {
                this.descriptor.element = ParamHelper.toHTMLElement(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"element\" isn't a valid DOM element: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.enabled = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isBoolean(value)) {
                this.descriptor.enabled = ParamHelper.toBoolean(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"enabled\" isn't a valid boolean: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.type = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                if (value === "global" || value === "scene") {
                    this.descriptor.type = ParamHelper.toString(value);
                }
                else {
                    throw new Error("[" + ParallaxBuilder.NAMESPACE + "] Value for \"type\" isn't valid, it should be \"global\" or \"scene\": \"" + value + "\"");
                }
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"type\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.speed = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.speed = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"speed\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.momentum = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.momentum = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"momentum\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.stagger = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.stagger = ParamHelper.toFloat(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"stagger\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.ease = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                this.descriptor.ease = ParamHelper.toString(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"ease\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.trigger = function (value, container) {
        if (value !== undefined) {
            if (ParamHelper.isHTMLElement(value)) {
                this.descriptor.trigger = ParamHelper.toHTMLElement(value);
            }
            else if (ParamHelper.isString(value)) {
                if (container !== undefined && ParamHelper.isHTMLElement(container)) {
                    var nodes = container.querySelectorAll(ParamHelper.toString(value));
                    if (nodes.length === 1) {
                        this.descriptor.trigger = ParamHelper.toHTMLElement(nodes[0]);
                    }
                    else if (nodes.length > 1) {
                        Logger.warning("[" + ParallaxBuilder.NAMESPACE + "] There are more than 1 element for trigger \"" + value + "\" in the given container. Using the first one.");
                    }
                    else {
                        throw new Error("[" + ParallaxBuilder.NAMESPACE + "] Could't find an element with query \"" + value + "\" in the given container.");
                    }
                }
                else {
                    var nodes = document.body.querySelectorAll(ParamHelper.toString(value));
                    if (nodes.length === 1) {
                        this.descriptor.trigger = ParamHelper.toHTMLElement(nodes[0]);
                    }
                    else if (nodes.length > 1) {
                        Logger.warning("[" + ParallaxBuilder.NAMESPACE + "] There are more than 1 element for trigger \"" + value + "\" in the body. Using the first one.");
                    }
                    else {
                        throw new Error("[" + ParallaxBuilder.NAMESPACE + "] Could't find an element with query \"" + value + "\" in the body.");
                    }
                }
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"trigger\" isn't a valid element or selector: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.duration = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.duration = ParamHelper.toInteger(value);
            }
            else if (ParamHelper.isPercentage(value)) {
                this.descriptor.duration = ParamHelper.toString(value);
            }
            else if (ParamHelper.isFunction(value)) {
                var durationMethod = value;
                if (durationMethod && ParamHelper.isNumber(durationMethod())) {
                    this.descriptor.duration = durationMethod;
                }
                else {
                    throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Function for \"duration\" should return a number.");
                }
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"duration\" isn't valid: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.hook = function (value) {
        if (value !== undefined) {
            if (!ParamHelper.isNumber(value) && ParamHelper.isString(value) && !ParamHelper.isHookValue(value)) {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"hook\" isn't valid: \"" + value + "\"");
            }
            else {
                if (ParamHelper.isString(value)) {
                    value = ParamHelper.toHookValue(value);
                }
                if (ParamHelper.isNumber(value)) {
                    if (value >= 0 && value <= 1) {
                        this.descriptor.hook = ParamHelper.toFloat(value);
                    }
                    else {
                        throw new RangeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"hook\" should be between 0 and 1: \"" + value + "\"");
                    }
                }
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.offset = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isNumber(value)) {
                this.descriptor.offset = ParamHelper.toInteger(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"offset\" isn't a valid number: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.indicator = function (value) {
        if (value !== undefined) {
            if (ParamHelper.isString(value)) {
                this.descriptor.indicator = ParamHelper.toString(value);
            }
            else {
                throw new TypeError("[" + ParallaxBuilder.NAMESPACE + "] Value for \"indicator\" isn't a valid string: \"" + value + "\"");
            }
        }
        return this;
    };
    ParallaxBuilder.prototype.build = function () {
        return this.descriptor;
    };
    ParallaxBuilder.NAMESPACE = "ParallaxBuilder";
    return ParallaxBuilder;
}());
export default ParallaxBuilder;
//# sourceMappingURL=parallax.builder.js.map